<script lang="ts">
 
 import { navigate } from "../../app.logic";
  import Tab from "../../components/Tab/Tab.svelte";
  import Tabs from "../../components/Tab/Tabs.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
import ActivityDetailPartGeneral from "./ActivityDetailPartGeneral.svelte";
  import { initDetail } from "./activity.store"; 
  import { user } from "../../app.store";
import type { IActivityDTO } from "../../services/DTO";


  export let oid: number;
  export let type: string;

  function onClose(){
    navigate(`/task`);   
  }
 
  function onSave(event){    
      let u : IActivityDTO = event.activity;
      navigate(`/task/${u.oid}/${u.entityType}`);
  }

</script>

<MainLayout>
  <ActivityDetailPartGeneral {oid} {type} entityId={null} on:close={() => onClose()} on:save={(ev) => onSave(ev.detail)} />
</MainLayout>
